import { Box, TextField, Typography } from '@mui/material';
import { AddCarrierDetails, validateName, validateShortcode } from '../../logic/add-carrier-form';

export interface DetailsStepProps {
  details: AddCarrierDetails;
  onChange: (details: AddCarrierDetails) => void;
  /** True once the project exists: its name and shortcode are no longer ours to change. */
  readOnly: boolean;
  /** Set when the API rejected the shortcode as already taken. */
  shortcodeError?: string;
  /** Validation is only surfaced once the user has tried to move on. */
  showValidation: boolean;
}

export function DetailsStep({ details, onChange, readOnly, shortcodeError, showValidation }: DetailsStepProps) {
  const nameError = showValidation ? validateName(details.name) : undefined;
  const shortcodeValidationError = showValidation ? validateShortcode(details.shortcode) : undefined;

  return (
    <Box
      style={{ gap: 20 }}
      sx={{
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <TextField
        label="Name"
        required
        autoFocus={!readOnly}
        disabled={readOnly}
        variant="outlined"
        size="small"
        fullWidth
        value={details.name}
        onChange={(event) => onChange({ ...details, name: event.target.value })}
        error={!!nameError}
        helperText={nameError ?? 'The carrier’s trading name. It appears on kiosks and on delivery records.'}
      />
      <TextField
        label="Shortcode"
        disabled={readOnly}
        variant="outlined"
        size="small"
        fullWidth
        value={details.shortcode}
        onChange={(event) => onChange({ ...details, shortcode: event.target.value })}
        error={!!(shortcodeError || shortcodeValidationError)}
        helperText={shortcodeError ?? shortcodeValidationError ?? 'Optional. Used in URLs. Letters and numbers only.'}
      />
      {readOnly && (
        <Typography variant="body2" color="textSecondary">
          The carrier’s project has already been created, so these can no longer be changed here.
        </Typography>
      )}
    </Box>
  );
}
